import { isPlatformBrowser, NgClass } from '@angular/common';
import {
  Component,
  DOCUMENT,
  HostListener,
  Inject,
  inject,
  OnInit,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SecondarySideMenuI } from '../../../shared/interfaces/secondary-side-menu.interface';
import { SIDE_MENU_ITEMS } from './constants/side-menu.constant';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-progress-reports-side-menu',
  imports: [TranslateModule, NgClass, RouterLink],
  templateUrl: './progress-reports-side-menu.component.html',
  styleUrl: './progress-reports-side-menu.component.scss',
})
export class ProgressReportsSideMenuComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private readonly platformID: Object
  ) {}

  private router = inject(Router);
  public route = inject(ActivatedRoute);
  sideMenuItems = SIDE_MENU_ITEMS;
  isSideMenuOpen = signal<boolean>(false);

  ngOnInit(): void {
    this.initScreenType();
  }

  public getSideMenuItemIcon(sideMenuItem: SecondarySideMenuI) {
    return this.router.url.endsWith('/' + sideMenuItem.route(''))
      ? sideMenuItem.activeIcon
      : sideMenuItem.nonActiveIcon;
  }

  public isCurrentRouteActive(sideMenuItem: SecondarySideMenuI) {
    return this.router.url.endsWith('/' + sideMenuItem.route(''));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event & { target: { innerWidth: number } }) {
    this.isSideMenuOpen.update(
      () => event.target?.innerWidth <= 700 && event.target?.innerWidth >= 500
    );
  }

  initScreenType() {
    if (isPlatformBrowser(this.platformID)) {
      this.isSideMenuOpen.update(
        () =>
          this.document.defaultView!.innerWidth <= 700 &&
          this.document.defaultView!.innerWidth >= 500
      );
    }
  }
}
